export enum ActivityMessagingType {
  UPDATE = '1',
  LEGAL = '2',
  SHOP = '3',
  FORMATION = '4',
  SHOP_IMAGE = '6',
  INFO_LBI = '7',
  INTERKAB_SOLUTIONS = '8',
}
